import type { components } from '@multaqa/api-client'

type LocalizedString = components['schemas']['LocalizedString']

/**
 * Pick a localised string for the active locale, falling back to English and
 * then to whichever locale the backend did provide.
 *
 * Bilingual text is stored as jsonb keyed by locale and is NOT forced to
 * include English (C3) — a record may carry only Arabic. The fallback chain
 * therefore has to end in "any key that exists", not in English.
 */
export function localizedText(value: LocalizedString | null | undefined, locale: string): string {
  if (!value) {
    return ''
  }
  return value[locale] ?? value.en ?? Object.values(value)[0] ?? ''
}
